export const rows = [
  { antes: 'Horas buscando qué ejercicio dar', con: '5 minutos. Todo listo.' },
  { antes: 'Clases repetitivas y predecibles', con: 'Variedad real. Cada semana diferente.' },
  { antes: 'No saber cómo adaptar para cada alumna', con: 'Progresiones y regresiones probadas.' },
  { antes: 'Miedo a cometer errores técnicos', con: 'Fichas con correcciones exactas.' },
  { antes: 'Alumnas que se van por aburrimiento', con: 'Comunidad que vuelve cada semana.' },
  { antes: 'Inseguridad al cobrar', con: 'Profesionalismo documentado.' },
  { antes: 'Clases sin estructura clara', con: 'Sistema completo y listo para enseñar.' }
];
